import { SEND_MESSAGE_USE_CASE, SendMessageUseCase, STOP_MESSAGE_USE_CASE, StopMessageUseCase, MESSAGE_REPOSITORY, MESSAGE_STREAMING_REPOSITORY } from '../../../../ai';
import { CREATE_AI_ATTACHMENT_FILES_USE_CASE, CreateAiAttachmentFilesUseCase, FILE_STORAGE_REPOSITORY, EXTERNAL_FILE_STORAGE_REPOSITORY, VALIDATE_PUBLIC_FILE_URL_USE_CASE, ValidatePublicFileUrlUseCase } from '../../../../file-storage';
export var chatUseCaseProviders = [{
  provide: SEND_MESSAGE_USE_CASE,
  useFactory: function useFactory(messageRepository, messageStreamingRepository) {
    return new SendMessageUseCase(messageRepository, messageStreamingRepository);
  },
  inject: [MESSAGE_REPOSITORY, MESSAGE_STREAMING_REPOSITORY]
}, {
  provide: STOP_MESSAGE_USE_CASE,
  useFactory: function useFactory(messageRepository) {
    return new StopMessageUseCase(messageRepository);
  },
  inject: [MESSAGE_REPOSITORY]
}, {
  provide: CREATE_AI_ATTACHMENT_FILES_USE_CASE,
  useFactory: function useFactory(fileStorageRepository, externalFileStorageRepository) {
    return new CreateAiAttachmentFilesUseCase(fileStorageRepository, externalFileStorageRepository);
  },
  inject: [FILE_STORAGE_REPOSITORY, EXTERNAL_FILE_STORAGE_REPOSITORY]
}, {
  provide: VALIDATE_PUBLIC_FILE_URL_USE_CASE,
  useFactory: function useFactory(fileStorageRepository) {
    return new ValidatePublicFileUrlUseCase(fileStorageRepository);
  },
  inject: [FILE_STORAGE_REPOSITORY]
}];